export const GET_USERS2 = "/prestiges";

export const GET_COURSES = "/course";

export const GET_SESSIONS = "/session";

export const server = process.env.REACT_APP_DUBFROG_BASE_SERVER_URL;

//------------------------------ Access Token
export const GET_ACESS_TOKEN =
  "https://vm-control-odn6jl2qqq-uc.a.run.app/get_access_token";

//------------------------------ USERS
export const GET_USERS = server + "/api/users/getusers";
export const UPDATE_USERS = server + "/api/users/update";
export const SIGN_IN_USER = server + "/api/users/login";
export const RESET_PASSWORD = server + "/api/users/resetpassword";
export const SIGN_UP_USER = server + "/api/users/register";
export const GET_MANAGED_TEAMS = server + "/api/users/teams/myTeams";
export const CREATE_TEAM = server + "/api/users/createteam";
export const ADD_USERS_TO_TEAM = server + "/api/users/adduserstoteam";
export const REMOVE_USERS_FROM_TEAM = server + "/api/users/removeusersfromteam";
export const UPDATE_TEAM_NAME = server + "/api/users/teams/updatename";

//----------------------------- Projects
export const GET_PROJECTS = server + "/api/projects/getprojects";
export const GET_PROJECTS_PAGINATED = server + "/api/projects/getprojectspaginated";
export const GET_PROJECT_SUMMARIES = server + "/api/projects/getprojectsummaries";
export const GET_AVAILABLE_PROJECTS = server + "/api/projects/getavailableprojects";
export const COPY_CHARACTERS_TO_PROJECT = server + "/api/projects/copycharacterstoproject";
export const GET_REMOVED_IMPORTED_CHARACTERS = server + "/api/projects/getRemovedImportedCharacters";
export const GET_TASKS_STATUS = server + "/api/services/gettaskstatus";
export const REGENERATE_TOKEN = server + "/api/tokens/regenerate-token";
export const GET_PROJECTS_FOR_USER = server + "/api/projects/getUserProjects";

export const GET_PROJECTS_FOR_SINGLE_USER =
  server + "/api/projects/getprojectforuser";

export const GET_CHARACTERS_FOR_PROJECT =
  server + "/api/projects/getcharactersforproject";

export const AddUpdateDelete_CHARACTER_FOR_PROJECT =
  server + "/api/projects/updatecharacters";

export const SOFT_DELETE_CHARACTER =
  server + "/api/projects/softDeleteCharacter";

export const APPEND_CHARACTER =
  server + "/api/projects/appendOrRestoreCharacter";

export const Assign_Character_To_All_Dialogues =
  server + "/api/projects/assignCharacterToAllDialogues";

export const UPLOAD_PROJECT_FILE = server + "/api/projects/upload";

export const TRANSCRIBE_PROJECT_FILE = server + "/api/projects/transcribe";

export const CREATE_PROJECT = server + "/api/projects/CreateProjectAndRole";
export const CREATE_PROJECT_NEW = server + "/api/projects/createproject";
export const CREATE_PROJECT_BATCH = server + "/api/projects/createprojectbatch";

export const UPDATE_PROJECT = server + "/api/projects/update";

export const DELETE_PROJECT = server + "/api/projects"; // DELETE /:projectId

//-------------------------- Audiobook endpoints
export const GET_AUDIOBOOKS = server + "/api/audiobook";
export const CREATE_AUDIOBOOK = server + "/api/audiobook/create";
export const GET_AUDIOBOOK_DETAILS = server + "/api/audiobook";  // /:projectId
export const UPDATE_AUDIOBOOK = server + "/api/audiobook/update";
export const UPLOAD_AUDIOBOOK_TEXT = server + "/api/audiobook/upload-text";
export const UPDATE_AUDIOBOOK_REVIEW = server + "/api/audiobook/review";
export const GET_AUDIOBOOK_DIALOGUES = server + "/api/audiobook/dialogues";  // /:projectId
export const EDIT_AUDIOBOOK = server + "/api/audiobook/edit";
export const MERGE_DIALOGUES = server + "/api/audiobook/mergeDialogues";
export const REGENERATE_DIALOGUE_AUDIO = server + "/api/audiobook/regenerate-dialogue";
export const UPDATE_DIALOGUE_VERSION = server + "/api/audiobook/update-dialogue-version";
export const SPLIT_DIALOGUE = server + "/api/audiobook/split-dialogue";
export const MERGING_AUDIOBOOK = server + "/api/services/mergingaudiobook";
export const DELETE_AUDIOBOOK = server + "/api/audiobook";
export const REGENERATE_ALL_VOICES = server + "/api/audiobook/regenerate-all-voices";
export const UPDATE_AUDIOBOOK_VOICE = server + "/api/audiobook/update-voice";
export const GENERATE_ENHANCED_TTS_AUDIO = server + "/api/audiobook/generate-enhanced-audio";


//----------------------------- Dialogues
export const GET_SPEECH_FOR_PROJECT =
  server + "/api/dialogues/getspeechsforproject";

export const GET_SPEECH_FOR_PROJECT_BY_PAGE =
  server + "/api/dialogues/getspeechsforprojectbypage";

export const GET_ALL_SPEECHES =
  server + "/api/dialogues/getAllSpeechsForExport";

export const SET_DIALOGUE_APPROVAL_STATUS =
  server + "/api/dialogues/setdialogueapprovalstatus";

export const GET_SPEECHS_DETAILS_FOR_PROJECT =
  server + "/api/dialogues/getspeechsdetailsforproject";

export const GET_SPEECH_POSITION_AROUND_TIME =
  server + "/api/dialogues/getspeechpositionaroundtime";

export const UPDATE_SPEECH_FOR_PROJECT =
  server + "/api/dialogues/updatespeechsforproject";

export const ADD_SPEECH_FOR_PROJECT = server + "/api/dialogues/addonespeech";
export const DELETE_SPEECH_FOR_PROJECT =
  server + "/api/dialogues/deleteonespeech";

export const GET_SPEECHS_FOR_SPEAKER =
  server + "/api/dialogues/getspeechsforspeaker";

export const UPDATE_SPEECH_RATING =
  server + "/api/dialogues/updateonespeechrating";


export const UPDATE_ONE_SPEECH = server + "/api/dialogues/updateonespeech";
export const UPDATE_DIALOGUE_USED_MODEL =
  server + "/api/dialogues/updateDialogueUsedModel";


//----------------------------- Search

export const SEARCH_SPEECH_FOR_PROJECT = server + "/api/dialogues/searchdialogues";
export const GET_DIALOGUE_ATTENTION_COUNTS =
  server + "/api/dialogues/attentioncounts";


//---------------------------- Dubbing Quality

export const CREATE_NEW_AUDIO = server + "/api/services/createnewaudio";
export const GENERATE_SOUND_EFFECT = server + "/api/services/generatesoundeffect";

export const CREATE_MULTIPLE_AUDIO =
  server + "/api/services/createmultipleaudios";

export const CREATE_ALL_VOCALS_AUTOMATICALLY =
  server + "/api/services/createaudiofordialogues";
export const ADJUST_AUDIO_SPEED =
  server + "/api/services/adjustaudiospeed";
export const ADJUST_AUDIO_SPEED_AUTO =
  server + "/api/services/adjustaudiospeedauto";
export const SPEED_ADJUST_BATCH =
  server + "/api/services/adjustaudiospeedbatch";
export const SPEED_ADJUST_BATCH_STATUS =
  server + "/api/services/adjustaudiospeedbatchstatus";
export const MEDIA_PLAYBACK_URLS =
  server + "/api/services/media/playback-urls";

//---------------------------- Sound Effects

export const GET_ALL_SOUNDEFFECTS =
  server + "/api/soundeffects/getsoundeffectforproject";
export const UPDATE_ONE_SOUNDEFFECTS =
  server + "/api/soundeffects/updateonesoundeffect";
export const ADD_ONE_SOUNDEFFECTS =
  server + "/api/soundeffects/addonesoundeffect";
export const DELETE_ONE_SOUNDEFFECTS =
  server + "/api/soundeffects/deleteonesoundeffect";
// Accept or reject what non-verbal detection wrote.
export const REVIEW_NONVERBAL_SOUNDEFFECT =
  server + "/api/soundeffects/reviewnonverbal";
export const REVIEW_NONVERBAL_DIALOGUE =
  server + "/api/soundeffects/reviewdialoguenonverbal";
export const RUN_NONVERBAL_DETECTION =
  server + "/api/services/nonverbaldetection";

//---------------------------- Lips Quality

export const GET_LIP = server + "/api/lipqualityassurance/getlipqa";
export const GET_LIP_BY_PAGE =
  server + "/api/lipqualityassurance/getlipqabypage";
export const UPDATE_ONE_LIP =
  server + "/api/lipqualityassurance/updateonelipqa";

//---------------------------- Speaker Face Identification

export const GET_ALL_FACE_DIMENSIONS =
  server + "/api/speakerfaceidentition/getspeakerfacestime";
export const DELETE_FACE_DIMENSION =
  server + "/api/speakerfaceidentition/deletefacedimensionsfordialogue";
export const ADD_FACE_DIMENSION =
  server + "/api/speakerfaceidentition/addfacedimensionsfordialogue";

//---------------------------- Final Qaulity Assurance

export const GET_ALL_QUALITYASSURANCE_VERSIONS =
  server + "/api/qualityassurances/getqafromproject";
export const GET_ALL_QUALITYASSURANCE_NOTES =
  server + "/api/qualityassurances/getqaforversion";
export const ADD_ONE_QUALITYASSURANCE_NOTE =
  server + "/api/qualityassurances/addoneqaforversion";
export const DELETE_ONE_QUALITYASSURANCE_NOTE =
  server + "/api/qualityassurances/deleteoneqaforversion";
export const UPDATE_ONE_QUALITYASSURANCE_NOTE =
  server + "/api/qualityassurances/updateoneqaforversion";

//---------------------------- Create a new audio cloud function api
export const CREATE_NEW_AUDIO_API =
  "https://us-central1-video-dub-e0a3e.cloudfunctions.net/createAudioApi";

export const CREATE_LIST_AUDIOS_TEXTS =
  "/api/services/createlistofaudiosandtexts";

//---------------------------- Transcribing Api
export const TRANSCRIBE = server + "/api/services/transcriberequest";
// export const TRANSCRIBE = server + "/api/projects/transcribe";
export const TRANSCRIBE_STATUS_CHECK =
  server + "/api/services/transcribestatus";

//---------------------------- Translating Api
export const TRANSLATE = server + "/api/services/translatedialogues";
export const UPLOAD_TRANSLATOR_VOICE = server + "/api/projects/upload"; // needs to be fixed
export const SRT = server + "/api/services/createsrtfile";
export const GET_SRT = server + "/api/services/srt-json";
export const API_CHARACTER_ACCENTS = `${server}/api/demo/get-character-accents`;

//---------------------------- Audio Chopping Api
export const AUDIO_CHOPPING = server + "/api/services/audiochopping";
export const AUDIO_CHOPPING_STATUS_CHECK =
  server + "/api/services/audiochoppingstatus";

//---------------------------- Audio Chopping Api
export const MERGING_AUDIO_API = server + "/api/services/mergingaudio";

export const MERGING_LIPS_API = server + "/api/services/merginglips";

export const MERGING_STATUS_CHECK = server + "/api/services/mergingaudio";

export const MERGING_VIDEO_API = server + "/api/services/mergingvideo";

export const MERGING_FULL_API = server + "/api/services/fullmerge";

//---------------------------- Voice Traning Api
export const VOICE_TRAINING = server + "/api/services/addvoiceidsforspeakers";
export const TRY_CLEAR_VOICES = server + "/api/services/tryclearvoices";
export const VOICE_TRAINING_STATUS_CHECK = server + "/api/services/voiceidsstatus";
export const GET_PROJECT_VERSION = server + "/api/services/projectVersion";


export const AUTOMATIC_VOICE_PROCESSING = server + "/api/dialogues/automaticvoiceprocessing";
export const VALIDATE_EMOTIONS = server + "/api/dialogues/validateemotions";
//---------------------------- Video and Audio upload apis

export const UPLOAD_VIDEO_DRIVE = server + "/api/services/uploadvideofromdrive";
export const UPLOAD_VIDEO_DROPBOX = server + "/api/services/uploadvideofromdropbox";
export const INGESTION_SERVICE = server + "/api/services/ingestion";
export const END_TO_END_AUTOMATION = server + "/api/services/endtoendautomation";
export const PROJECT_SUBTITLES = server + "/api/services/project-subtitles";
export const MAP_TRANSLATION = server + "/api/services/maptranslation";
export const CREATE_NEW_COLLECTION = server + "/api/services/createnewcollection";
export const GET_TEAM_COLLECTIONS = server + "/api/services/getteamcollections";
export const MEDIA_INGEST = server + "/api/services/media/ingest";
export const CREATE_ASSET_UPLOAD_SESSION = server + "/api/services/assets/upload-session";
export const FINALIZE_MEDIA_UPLOAD = server + "/api/services/media/finalize-upload";

export const UPLOAD_AUDIO_DRIVE = server + "/api/services/uploadaudiofromdrive";
export const UPLOAD_AUDIO_DROPBOX =
  server + "/api/services/uploadaudiofromdropbox";
export const URL_UPLOAD = server + "/api/services/urlupload";
export const ADD_FILE_METADATA = server + "/api/services/addfilemetadata";

export const DEMUCS_SPLIT = server + "/api/services/demucssplit";

export const REQUEST_POLL_TRANSCRIBE =
  server + "/api/services/requestPollTranscribe";

//-------------------------- faces services

export const FACE_DETECTOR = server + "/api/services/facedetector";
export const SYNC_LIPS = server + "/api/services/lip-sync";
export const GET_LIP_SYNC_STATUS = server + "/api/services/lip-sync/status";
// Deprecated legacy VM/IP implementation, retained for rollback only.
export const SYNC_LIPS_DEPRECATED = server + "/api/services/facelips";


export const ATTRIBUTION = server + "/api/demo/get-attributions";

//-------------------------- Character Customization
export const DESIGN_CHARACTER_VOICE = server + "/api/services/design-voice";
export const REMIX_CHARACTER_VOICE = server + "/api/services/remix-voice";
export const ADD_REMIXED_VOICE_TO_CHARACTER = server + "/api/services/add-voice";
// Redo a character's lines with a new voice: /:projectId/voice-redo-jobs,
// /count, and /:jobId/cancel.
export const VOICE_REDO_JOBS = server + "/api/projects";
// A playable sample of a character's voice: /:projectId/voice-samples.
export const VOICE_SAMPLES = server + "/api/projects";

export const CHARACTER_STATUSES_URL = server + "/api/services/get-character-statuses";
export const EVALUATE_ALL_VOICES = server + "/api/services/evaluate-all-voices";
export const TRAIN_SINGLE_VOICE = server + "/api/services/trainsinglevoice";

//------------------------------ QA review submission
export const QA_REVIEW_START = server + "/api/qareview/start";
export const QA_REVIEW_SUBMIT = server + "/api/qareview/submit";
export const QA_REVIEW_RETURN = server + "/api/qareview/return";
// GET `${QA_REVIEWS}/${projectId}` (admins)
export const QA_REVIEWS = server + "/api/qareview";

// QA time tracking (404 while the backend has it turned off)
export const QA_TIME_CONFIG = server + "/api/qatime/config";
export const QA_TIME_HEARTBEAT = server + "/api/qatime/heartbeat";
export const QA_TIME_HOURS = server + "/api/qatime/hours";
export const QA_TIME_CONFIRM = server + "/api/qatime/timesheets/confirm";
// GET `${QA_TIME_TIMESHEETS}/${projectId}`; POST `${QA_TIME_TIMESHEETS}/${id}/approve|not-payable|adjustments` (admins)
export const QA_TIME_TIMESHEETS = server + "/api/qatime/timesheets";
// POST rates; GET `${QA_TIME_RATES}/${userId}` (admins)
export const QA_TIME_RATES = server + "/api/qatime/rates";
// GET `${QA_TIME_ACTIVITY}/${projectId}?language=&userId=&from=&to=` (admins)
export const QA_TIME_ACTIVITY = server + "/api/qatime/activity";
